<template>
    <user :users="dlabData.userData.users" />
</template>


<script>
import dlabData from '@/store/store.js';
import User from './User.vue'


export default {
    components: {
        User
    },
    name: 'AllUsers',
    data() {
        return {
            dlabData,
            isLoading: false,
            fetchResult: ''
        }
    },
    methods: {

    },
    mounted() {
        
    }
}
</script>